var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9213 0.589355H4.4401C2.18774 0.589355 0.361328 2.45044 0.361328 4.74555V10.5918C0.361328 12.887 2.18774 14.748 4.4401 14.748H15.9213C18.1737 14.748 20.0001 12.887 20.0001 10.5918V4.74555C20.0001 2.45044 18.1737 0.589355 15.9213 0.589355ZM13.1656 7.95477L7.79604 10.5655C7.65406 10.6379 7.48626 10.5261 7.48626 10.3683V4.9823C7.48626 4.81789 7.65406 4.71267 7.8025 4.78501L13.172 7.56019C13.3334 7.64568 13.3269 7.87585 13.172 7.95477H13.1656Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.bfb6631d79ccd880d598b1b37a420507.svg";
export { ForwardRef as ReactComponent };